@use '@/scss/underscore' as _;

.search {
  width: 100%;
}

.icon {
  color: var(--color-text-secondary);
}
